export default "__VITE_ASSET__HEtI_I34__"